export default __webpack_public_path__ + "static/media/insightdata_senario.05a5b882.svg";